/* eslint no-console:0 */
// This file is automatically compiled by Webpack and Jets, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import "../css/application.css";
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import * as Sentry from "@sentry/browser";
import "regenerator-runtime/runtime";

Sentry.init({
  dsn:
    "https://43f89f4d6d614ce3ae83d2828a3f2932@o171351.ingest.sentry.io/5204293",
  environment: process.env.JETS_ENV,
  debug: true,
});
const application = Application.start();
const defaultErrorHandler = application.handleError;
const sentryErrorHandler = (err) => {
    defaultErrorHandler(err);
    Sentry.captureException(err);
};

const context = require.context("../src/stimulus/controllers", true, /\.js$/);
application.load(definitionsFromContext(context));
application.handleError = sentryErrorHandler;
window.getApplicationController = function() {
    return application.controllers.find(controller => {
        return controller.context.identifier === "application";
    });
};
